import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IDashboardJobApi, IDashboardJobsInfoApi } from './dashboardJobsTypes';

export enum DashboardJobsType {
  OPEN = 'open',
  ACTION_REQUIRED = 'action-required',
  FILLED = 'filled',
}

export interface IGetDashboardJobsParams {
  page: number;
  limit: number;
  type: DashboardJobsType;
}

async function getDashboardJobs({
  type,
  page,
  limit,
}: IGetDashboardJobsParams): Promise<IDashboardJobApi[]> {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IDashboardJobApi[]>(`/jobs/dashboard/${type}`, {
    headers,
    params: {
      page: page ?? 1,
      limit: limit ?? 10,
    },
  });

  return response.data;
}

async function getDashboardJobsInfo(): Promise<IDashboardJobsInfoApi> {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get<IDashboardJobsInfoApi>(`/jobs/dashboard`, { headers });
  return response.data;
}

export const dashboardJobsApi = {
  getDashboardJobs,
  getDashboardJobsInfo,
};
